// extracted by mini-css-extract-plugin
export default {"wrapper":"Login__wrapper___3DvB8"};